<template>
    <div class="a">
        <top></top>
        <navs></navs>
        <div class="content">

            <div class="cont">
                <div class="cont_a">
                    <div class="bule"></div>
                    <div class="p">{{ name }}</div>
                </div>
                <!-- <div class="cont_left"> -->
                <div style="background-color: #fff;padding-top: 20px;">
                    <el-carousel :interval="4000" type="card" height="340px" :autoplay="false" arrow="always">
                        <el-carousel-item v-for="item in list" :key="item.id" >

                           
                            <img :src="item.placard" alt="" style="width: 500px; height: 280px;" @click="transfrom(item.id)">
                            <div style="height: 50px;width: 100%;display: flex;align-items: center;justify-content: center;">
                                <h3>{{ item.name }}</h3>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div style="color: #fff;">
                    <div class="cont_left_top" v-if="list != []">
                        <video :src="vid[0].url" width="100%" height="396px" controls></video>
                    </div>
                    <div class="cont_left_top" v-else>
                        <div style="width: 100%;height: 80px;display: flex;align-items: center;justify-content: center;font-size: 20px;color: #333333;">
                            {{ name }}
                        </div>
                        <div v-html="fwb"></div>
                    </div>
                </div>

            </div>
        </div>
        <bottom></bottom>
    </div>
</template>
<script>
import top from "@/components/top.vue"
import bottom from "@/components/bottom.vue"
import navs from "@/components/navs.vue"
import axios from "axios"


export default {
    name: "vinit",
    components: {
        top,
        bottom,
        navs
    },
    data() {
        return {
            sj: {},
            vid: [],
            list: [],
            recommend: [],
            name: "",
            fwb: "",
            count: 0,
            d: "",
            swiper: null,
        }
    },
    created() {
        this.name = this.$route.query.name
        
        axios({
            method: "GET",
            url: "https://www.jnccljh.com/api/records/pages",
            params: {
                "albumId": this.$route.query.id,
                // "pageSize": 10
            }
        }).then(res => {
            // this.fwb = res.data.data.abstracts
            // this.name = res.data.data.name
            this.list = res.data.data.records
            axios({
            method: "GET",
            url: "https://www.jnccljh.com/api/records/" +res.data.data.records[0].id
        }).then(res => {
            console.log(res)
            this.vid = res.data.data.metadataList
            this.name = res.data.data.name
            this.fwb = res.data.data.abstracts
        })
        })
        axios({
            method: "GET",
            url: "https://www.jnccljh.com/api/records/" + this.$route.query.id + "/tags"
        }).then(res => {
            console.log(res)
            this.recommend = res.data.data
        })

    },
    mounted() {
        this.getSwiper()
    },

    methods: {
        load() {
            this.count += 2
        },
        transfrom(item) {
            this.d = item
            axios({
                method: "GET",
                url: "https://www.jnccljh.com/api/records/" + item
            }).then(res => {

                this.vid = res.data.data.metadataList
                this.name = res.data.data.name
            })
        },
        recomm(item) {
            this.$router.push({ path: "/album", query: { id: item } })
        },
        getSwiper() {
            console.log(1)
            this.swiper = new Swiper(".swiper-container", {
                loop: true, // 无缝
                autoplay: { //自动开始
                    delay: 3000, //时间间隔
                    disableOnInteraction: false, //*手动操作轮播图后不会暂停*
                },
                paginationClickable: true,
                slidesPerView: 4, // 一组三个
                spaceBetween: 30, // 间隔
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
                observer: true,
                observeParents: true,
                // 如果需要分页器
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true, // 分页器可以点击
                },
            })
        }

    }
}
</script>
<style scoped>
ul li {
    list-style: none;
}

.a {
    width: 100%;
    /* height: 100vh; */
    margin: 0;
    padding: 0;
    background-color: #F7F7F7;
}

.content {
    width: 100%;
    /* height: 480px; */
    /* height: 1330px; */
    background-image: url(../image/back.png);
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
}

.cont {
    width: 70%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin-top: 25px;
    margin-bottom: 50px
}

.cont_left {
    width: 65%;

}

.cont_left_top {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    width: 100%;
    height: 396px;
    background-color: #FFFFFF;
}

/* .title{
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 100%;
    height: 66px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.image{
    width: 100%;
    height: 300px;
    display: flex;
    align-items: center;
} */
.cont_right {
    width: 28%;
}

.cont_a {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.bule {
    width: 5px;
    height: 16px;
    background: #1463FF;
    /* margin: 20px 0; */

}

.p {
    margin-left: 5px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 17px;
    color: #333333;
    line-height: 17px;
    font-style: normal;
}

.directory {
    height: 425px;
    width: 100%;
    background-color: #FFFFFF;
    display: flex;
    /* align-items: center; */
    flex-direction: column;
    padding-top: 10px;
    padding-bottom: 50px;
}

.recommend {
    margin: 20px 0;
    width: 100%;
    height: 48px;
    display: flex;
    align-items: center;
    background-color: #FFFFFF;
    /* padding-left: 20px; */
}

.label {
    width: 59px;
    height: 27px;
    background: #EEEEEE;
    border-radius: 13px;
    border: 1px solid #979797;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    color: #333333;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 8px;
}

.label:hover {
    background: #F9F9F9;
    border-radius: 13px;
    border: 1px solid #1463FF;
    width: 59px;
    height: 27px;
    background: #EEEEEE;
    border-radius: 13px;
    color: #1463FF;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 13px;
    margin-right: 8px;

    display: flex;
    align-items: center;
    justify-content: center;
}

.text {
    width: 80%;
    height: 40px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #333333;
}

.text:hover {
    width: 80%;
    height: 40px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 13px;
    color: #1463FF;
}

.hidden {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.con {
    color: #1463FF;
}

.banshi {
    width: 100%;
    margin: 0 auto;
    padding: 70px 0;


}

.swiper-slide {
    position: relative;
    height: 348px;
    width: 444px;
    padding: 36px 22px;
    background-repeat: no-repeat;
    background-size: contain;
    background-color: #F7F8FA;
}
</style>


// WEBPACK FOOTER //
// src/views/adetail.vue